import React, { useState } from "react"
import { Box, Button, MenuItem, TextField, Typography } from "@mui/material"
import { style } from "../../../../utils/utils";
import { addGradingToWorker } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

const AddNewGrade = ({setIsModalOpen, getGradings, getAllGradingsAssignments}: any) => {
    const {state} = useAuth();
    const [attendance, setAttendance] = useState<any>(0);
    const [attitude, setAttitude] = useState<any>(0);
    const [siteFeedback, setSiteFeedback] = useState<any>(0);
    const [searchParams, ] = useSearchParams();
    
    const addGradings = async () => {
        const response: any = await addGradingToWorker(state.user?.token, {
            attendance: attendance,
            attitude: attitude,
            siteFeedback: siteFeedback,
            workerId: searchParams.get('workerId')
        })

        if(response.status === 200) {
            getGradings();
            getAllGradingsAssignments();
            setIsModalOpen(false);
            toast.success('Grading added successfully');
        }
    };

    return (
        <Box sx={style}>
            <Box display="grid" gridTemplateColumns={{xs: "1fr", md: "1fr"}} gap={4} m={1}>
                <Typography fontWeight={"600"}>Add New Gradings</Typography>
                <TextField
                    select
                    id="demo-select-small"
                    size="small"
                    label="Attendance / Punctuality"
                    value={attendance}
                    onChange={(e) => setAttendance(e.target.value)}
                >
                    <MenuItem value={0}>None</MenuItem>
                    <MenuItem value={1}>Bad</MenuItem>
                    <MenuItem value={2}>Fair</MenuItem>
                    <MenuItem value={3}>Good</MenuItem>
                    <MenuItem value={4}>Excellent</MenuItem>
                </TextField>
                <TextField
                    select
                    id="demo-select-small"
                    size="small"
                    label="Attitude / Work ethic"
                    value={attitude}
                    onChange={(e) => setAttitude(e.target.value)}
                >
                    <MenuItem value={0}>None</MenuItem>
                    <MenuItem value={1}>Bad</MenuItem>
                    <MenuItem value={2}>Fair</MenuItem>
                    <MenuItem value={3}>Good</MenuItem>
                    <MenuItem value={4}>Excellent</MenuItem>
                </TextField>
                <TextField
                    select
                    id="demo-select-small"
                    size="small"
                    label="Site Feedback"
                    value={siteFeedback}
                    onChange={(e) => setSiteFeedback(e.target.value)}
                >
                    <MenuItem value={0}>None</MenuItem>
                    <MenuItem value={1}>Bad</MenuItem>
                    <MenuItem value={2}>Fair</MenuItem>
                    <MenuItem value={3}>Good</MenuItem>
                    <MenuItem value={4}>Excellent</MenuItem>
                </TextField>
                <Button variant="contained" style={{boxShadow: 'none'}} onClick={addGradings}>
                    Save
                </Button>
            </Box>
        </Box>
    )
}

export default AddNewGrade;
